import React, { createContext, useCallback, useMemo, useState } from "react";
import { ContactUsModal, FormType } from "Components/Modal";
import { EnterpriseDemoRequestMode, SolutionType } from "Services/API/API";

import "Validation/yup/methods";

enum SolutionEnum {
   individual = SolutionType.Individual,
   team = SolutionType.Team,
   business = SolutionType.Business,
   enterprise = SolutionType.Enterprise,
}

export interface ContactUsContextValue {
   open: (id?: string) => void;
   close: () => void;
}

export interface ContactUsProviderProps {
   mode: EnterpriseDemoRequestMode
}

export const ContactUsContext = createContext<ContactUsContextValue>(
   {} as ContactUsContextValue
);

export const ContactUsProvider: React.FC<ContactUsProviderProps> = ({
   children,
   mode
}) => {
   const [isOpen, setIsOpen] = useState(false);
   const [solution, setSolution] = useState<SolutionType | undefined>(
      undefined
   );

   const open = useCallback((id?: string) => {
      setSolution(id ? SolutionEnum[id] : undefined);
      setIsOpen(true);
   }, []);

   const close = useCallback(() => {
      setSolution(undefined);
      setIsOpen(false);
   }, []);

   const contextValue = useMemo(() => ({ open, close }), [open, close]);

   return (
      <ContactUsContext.Provider value={contextValue}>
         {children}
         {isOpen && (
            <ContactUsModal
               isOpen
               centered
               toggle={close}
               formType={FormType.Specific}
               mode={mode}
               formName="Contact us"
               defaultValues={{
                  solution,
               }}
            />
         )}
      </ContactUsContext.Provider>
   );
};
